import firebase from "firebase/app";

export const momentToFirestore = (x: moment.Moment) => {
  return firebase.firestore.Timestamp.fromMillis(x.valueOf());
};

export const now = () => {
  return firebase.firestore.Timestamp.now();
};
